import React from 'react'
import styles from './styles.css'
import Container from 'orionsoft-parts/lib/components/Container'
import Coins from './Coins'

export default class Footer extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.container}>
        <Container>
          <Coins />
          <div className={styles.logo}>
            <a href="https://orionx.com" target="_blank" rel="noopener noreferrer">
              <img src="/logo-black.svg" alt="logo" />
            </a>
          </div>
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Home/Layout/Footer/index.js